<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0 banner-text">PC本地部署大模型</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">PC本地部署大模型</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						我們提供企業級PC端大模型本地化部署產品，支援全鏈路數據安全體系，提供百億級模型輕量化服務引擎，在保證企業數據安全的同時，賦能企業業務，實現降本增效。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">產品優勢</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">零門檻極速部署</div>
									<div class="t2">
										圖形化安裝引擎：提供可視化安裝包（如LM Studio/Ollama），用戶僅需簡單操作即可完成模型部署，徹底擺脫命令行配置；<br>
										自適應硬件調度：支援CPU/GPU混合負載與動態量化技術，在RTX 3060（12GB顯存）或16GB記憶體設備上流暢運行7B~13B參數模型。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">多模型敏捷切換系統</div>
									<div class="t2">
										預置模型倉庫：集成Llama3、Qwen1.5、DeepSeek-R1等20+主流開源模型，支援用戶按任務需求（如代碼生成/文案創作）自由切換；<br>
										全離線能力矩陣：模型推理、微調訓練、知識庫構建等功能均可在斷網環境運行，通過記憶體隔離技術確保數據100%留存本地，滿足軍工、醫療等敏感場景需求。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">企業級知識管理中樞</div>
									<div class="t2">
										多模態文檔解析：自動解析Word/PDF/圖片中的文本與表格，結合OCR與NLP技術實現非結構化數據向量化；<br>
										智能知識圖譜：基於RAG增強構建可關聯的私有知識網絡，支援"合同條款追溯""技術文檔溯源"等複雜查詢，有效提升檢索速度。
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">場景化AI工作箱</div>
										<div class="t2">
											零代碼應用工廠：內置多個高頻場景模板，開箱即用：<br>
											智能寫作：短時間內生成合規合同/商業報告，支援法律條款自動校驗；<br>
											專業潤色：融合行業術語庫，實現語法糾錯與風格優化，有效提高過檢率；<br>
											實時決策助手：基於本地知識庫解答技術問題。
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/pc1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">應用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/pc2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">企業級知識管家</div>
										<div class="t2">
											全自動知識治理：自動歸檔合同、技術文檔等非結構化數據，通過OCR+NLP實現多模態解析（PDF/Word/圖片）<br>
											語義智能引擎：基於RAG增強的向量檢索技術，支援"模糊查詢-關聯推薦-溯源追蹤"全鏈路，提升知識復用效率
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">法務與審計助手</div>
										<div class="t2">
											智能合同審查：本地化部署的Legal-BERT模型自動識別條款漏洞（如歧義表述、違約風險）<br>
											私有化報告生成：結合企業合規庫生成審計報告初稿，支援國密SM4加密存儲，滿足等保3.0要求
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">行業專家系統</div>
									<div class="t2">
										知識注入技術：通過LoRA微調將航運/醫療等專業知識嵌入模型
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">智能創作工作室</div>
									<div class="t2">
										多輪交互優化：基於記憶功能實現風格遷移（如技術文檔→科普文案），保留專業性的同時提升可讀性<br>
										全流程閉環：從初稿生成→術語校正→合規審查均在本地完成，杜絕敏感內容外泄
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
